















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { startupMaturityList, CEOSuitabilityList, maintenanceStrategyList } from '@/utils/kp';
import { getSeedKpDetail, getSeedKpList, setKpField, updateKpField, onUpdateCEOSuitability } from '@/api/kp';

import selectMember from '@/components/project/selectMember.vue';

import { Modal } from 'ant-design-vue';

interface User {
  id: number;
  nickname: string;
}
@Component({
  components: {
    selectMember
  }
})
class kpEdit extends Vue {
  modifyUsers: User[] = [];
  queryUsers: User[] = [];

  labelCol: object = { span: 6 };
  wrapperCol: object = { span: 17 };
  form: object = {
    name: '',
    educationExperience: '',
    workExperience: '',
    individuality: '',
    maintainer: undefined,
    maintainerAid: '',
    CEOSuitability: '待定',
    maintenanceStrategy: '待定',
    startupMaturity: '待定',
    contacts: '',
    info: '',
    auth: 'seed内部公开'
  };
  confirmLoading: boolean = false;
  startupMaturityList: Array<string> = startupMaturityList;
  CEOSuitabilityList: Array<string> = CEOSuitabilityList;
  maintenanceStrategyList: Array<string> = maintenanceStrategyList;

  maintainerTmp: Array<object> = [];
  maintainerAidTmp: Array<object> = [];
  ceoTmp: string = '';
  CEOreasonModal: boolean = false;
  CEOreason: string = '';
  body: object = {};
  record: string = '';
  saveLoading: boolean = false;

  @Prop()
  visible;

  @Prop()
  type;

  @Prop()
  kpInfo;

  @Watch('kpInfo')
  kpInfoChange(value) {
    if (value && value.baseInfo) {
      let {
        baseInfo,
        educationExperience,
        workExperience,
        individuality,
        maintainer,
        maintainerAid,
        CEOSuitability,
        maintenanceStrategy,
        startupMaturity,
        contacts,
        info,
        auth
      } = value;
      this.ceoTmp = CEOSuitability.value;
      this.form = {
        name: baseInfo.name,
        educationExperience: educationExperience ? this.getText(educationExperience.value) : '',
        workExperience: workExperience ? this.getText(workExperience.value) : '',
        individuality: individuality ? this.getText(individuality.value) : '',
        maintainer: maintainer.value.id,
        maintainerAid: maintainerAid && maintainerAid.value ? maintainerAid.value.map(_ => _.id).join(',') : '',
        CEOSuitability: CEOSuitability ? CEOSuitability.value : '待定',
        maintenanceStrategy: maintenanceStrategy ? maintenanceStrategy.value : '待定',
        startupMaturity: startupMaturity ? startupMaturity.value : '待定',
        contacts: contacts ? this.getText(contacts.value) : '',
        info: info ? this.getText(info.value) : '',
        auth: auth ? auth.value : 'seed内部公开'
      };
      this.maintainerTmp = [{ ...maintainer.value }];
      this.maintainerAidTmp = maintainerAid && maintainerAid.value ? maintainerAid.value.map(_ => ({ ..._ })) : [];
    }
  }

  // transform str to DOM and return the innerText of the DOM
  getText(str) {
    let div = document.createElement('div');
    div.innerHTML = str;
    return div.innerText;
  }

  handleCancel() {
    this.form = {
      name: '',
      educationExperience: '',
      workExperience: '',
      individuality: '',
      maintainer: undefined,
      maintainerAid: '',
      CEOSuitability: '待定',
      maintenanceStrategy: '待定',
      startupMaturity: '待定',
      contacts: '',
      info: '',
      auth: 'seed内部公开'
    };
    this.maintainerTmp = [];
    this.maintainerAidTmp = [];
    this.$emit('hide', 'cancel');
  }

  async handleOk() {
    try {
      if (!this.form['name']) {
        throw new Error('请填写客户姓名');
      } else if (!this.form['maintainer']) {
        throw new Error('请填写主负责人');
      }
      this.confirmLoading = true;
      if (this.type === 'new') {
        let res1 = await setKpField({
          ...this.form,
          source: 1
        });
        this.confirmLoading = false;
        if (res1.code === 200) {
          let id = res1.data;
          if (this.record) {
            let res2 = await setKpField({
              kpId: id,
              source: 1,
              latestDevelopment: this.record
            });
          }
          this.form = {
            name: '',
            educationExperience: '',
            workExperience: '',
            individuality: '',
            maintainer: undefined,
            maintainerAid: '',
            CEOSuitability: '待定',
            maintenanceStrategy: '待定',
            startupMaturity: '待定'
          };
          this.record = '';
          this.maintainerTmp = [];
          this.maintainerAidTmp = [];
          this.$message.success('创建成功');
          setTimeout(() => {
            window.open(window.location.origin + `/kp/seed/detail?id=${id}`);
          }, 1000);

          this.$emit('hide', 'new');
        }
      } else {
        let {
          baseInfo,
          educationExperience,
          workExperience,
          individuality,
          maintainer,
          maintainerAid,
          CEOSuitability,
          maintenanceStrategy,
          startupMaturity,
          auth,
          contacts,
          info
        } = this.kpInfo;
        this.body = {};
        this.body[workExperience.id] = this.form['workExperience'];
        this.body[individuality.id] = this.form['individuality'];
        this.body[CEOSuitability.id] = this.form['CEOSuitability'];
        this.body[maintainer.id] = this.form['maintainer'];
        this.body[maintainerAid.id] = this.form['maintainerAid'];
        this.body[startupMaturity.id] = this.form['startupMaturity'];
        this.body[educationExperience.id] = this.form['educationExperience'];
        this.body[maintenanceStrategy.id] = this.form['maintenanceStrategy'];
        this.body[contacts.id] = this.form['contacts'];
        this.body[info.id] = this.form['info'];
        this.body[auth.id] = this.form['auth'];
        if (this.ceoTmp && this.ceoTmp !== this.form['CEOSuitability'] && this.ceoTmp !== '待定') {
          this.CEOreasonModal = true;
          this.confirmLoading = false;
        } else {
          this.save();
        }
      }
    } catch (e) {
      console.log(e);
      this.$message.error(e.message);
      this.confirmLoading = false;
    }
  }

  choseMaintainer(members, type) {
    if (type === 'maintainer') {
      this.maintainerTmp = members;
      this.form['maintainer'] = this.maintainerTmp[0]['id'];
    } else if (type === 'maintainerAid') {
      this.maintainerAidTmp = members;
      this.form['maintainerAid'] = this.maintainerAidTmp.map(_ => _['id']).join(',');
    }
  }

  delMaintainer(user, type) {
    if (type === 'maintainer') {
      this.maintainerTmp = [];
      this.form['maintainer'] = undefined;
    } else if (type === 'maintainerAid') {
      this.maintainerAidTmp = this.maintainerAidTmp.filter(_ => _['id'] !== user.id);
      this.form['maintainerAid'] = this.maintainerAidTmp.map(_ => _['id']).join(',');
    }
  }

  async save() {
    try {
      if (this.CEOreasonModal && this.CEOreason === '') {
        this.$message.error('请填写原因');
      } else {
        let { baseInfo } = this.kpInfo;
        let res3;
        if (this.CEOreasonModal) {
          this.saveLoading = true;
          res3 = await onUpdateCEOSuitability({
            kpId: baseInfo.id,
            ceoSuitabilityFrom: this.ceoTmp,
            ceoSuitabilityTo: this.form['CEOSuitability'],
            reason: this.CEOreason
          });
        }
        let res = await updateKpField({
          ...this.body
        });
        let res2 = await setKpField({
          source: 1,
          kpId: baseInfo.id,
          name: this.form['name']
        });
        this.confirmLoading = false;
        this.saveLoading = false;
        if (res.code === 200 && res2.code === 200 && (!res3 || res3.code === 200)) {
          this.form = {
            name: '',
            educationExperience: '',
            workExperience: '',
            individuality: '',
            maintainer: undefined,
            maintainerAid: '',
            CEOSuitability: '待定',
            maintenanceStrategy: '待定',
            startupMaturity: '待定'
          };
          this.CEOreason = '';
          this.maintainerTmp = [];
          this.maintainerAidTmp = [];
          this.$message.success('编辑成功');
          this.CEOreasonModal = false;
          this.$emit('hide', 'edit');
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
}

export default kpEdit;
